import React from 'react';
import UserTable from '../../components/Tables/UserTable'; 
import './UserPage.css';

const UserPage = () => {
  return (
    <div className="user-page-container">
      
      <UserTable />
    </div>
  );
};

export default UserPage;